import { render, staticRenderFns } from "./lc.vue?vue&type=template&id=21815191&"
import script from "./lc.vue?vue&type=script&lang=js&"
export * from "./lc.vue?vue&type=script&lang=js&"
import style0 from "./lc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports